import React from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { organizationUsersById } from "reduxSlices/organizationUsersSlice"
import { getTaskUserIds } from "reduxSlices/formSubmissionSlice"
import { FormsyMentionableTextInput } from "shared/inputs"

const EntryValue = ({ name, initialValue, taskId }) => {
  const taskUserIds = useSelector(getTaskUserIds(taskId), isEqual)
  const activeTaskUsers = useSelector(organizationUsersById(taskUserIds, { excludeInactive: true }), isEqual)

  return (
    <div className="p-8 bg-white rounded-lg edit-submission-question">
      <FormsyMentionableTextInput
        className="multi-entries-answer-field max-h-64 overflow-y-auto"
        name={name}
        placeholder="Comment"
        required
        users={activeTaskUsers}
        validations={{
          isNotBlankString: true,
          noExcelMetacharacters: true,
          noHTML: true,
        }}
        value={initialValue}
        validationErrors={{ isDefaultRequiredValue: "required" }}
      />
    </div>
  )
}

EntryValue.propTypes = {
  name: types.string.isRequired,
  initialValue: types.string.isRequired,
  taskId: types.number.isRequired,
}

export default EntryValue
